import { LanguageCodes } from "Infrastructure/Api/Api";

const BROWSER_LANG_TO_LANGUAGE_CODE: Record<string, LanguageCodes> = {
  cs: LanguageCodes.Czech,
  en: LanguageCodes.English,
  de: LanguageCodes.Deutsch,
};

const LANGUAGE_CODE_TO_I18N: Record<LanguageCodes, string> = {
  [LanguageCodes.Czech]: "cs",
  [LanguageCodes.English]: "en",
  [LanguageCodes.Deutsch]: "de",
  [LanguageCodes.French]: "fr",
  [LanguageCodes.Italian]: "it",
  [LanguageCodes.Spanish]: "es",
  [LanguageCodes.Polish]: "pl",
  [LanguageCodes.Dutch]: "nl",
  [LanguageCodes.Romanian]: "ro",
  [LanguageCodes.Hungarian]: "hu",
  [LanguageCodes.Portuguese]: "pt",
  [LanguageCodes.Swedish]: "sv",
  [LanguageCodes.Bulgarian]: "bg",
  [LanguageCodes.Danish]: "da",
  [LanguageCodes.Finnish]: "fi",
  [LanguageCodes.Slovak]: "sk",
  [LanguageCodes.Croatian]: "hr",
  [LanguageCodes.Lithuanian]: "lt",
  [LanguageCodes.Slovenian]: "sl",
  [LanguageCodes.Latvian]: "lv",
  [LanguageCodes.Estonian]: "et",
  [LanguageCodes.Greek]: "el",
  [LanguageCodes.Maltese]: "mt",
  [LanguageCodes.Irish]: "ga",
};

const LANGUAGE_STORAGE_KEY = "vivelo_language";

export function detectBrowserLanguageCode(): LanguageCodes {
  const browserLang = navigator.language?.split("-")[0];
  return BROWSER_LANG_TO_LANGUAGE_CODE[browserLang] ?? LanguageCodes.English;
}

export function languageCodeToI18n(code: LanguageCodes): string {
  return LANGUAGE_CODE_TO_I18N[code] ?? "en";
}

/**
 * Returns the saved language from localStorage, or falls back to browser detection.
 */
export function getSavedOrDetectedLanguage(): string {
  const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (saved && ["cs", "en", "de"].includes(saved)) {
    return saved;
  }
  return languageCodeToI18n(detectBrowserLanguageCode());
}

/**
 * Persists the current i18n language code to localStorage.
 */
export function saveLanguagePreference(i18nCode: string): void {
  localStorage.setItem(LANGUAGE_STORAGE_KEY, i18nCode);
}
